module.exports = __webpack_public_path__ + "static/media/FAQ_icon.90712a7f.svg";